import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        auth: {
            token: "",
            adminUser: {}
        },
        course: {
            _id:'',
            courseId: "",
            courseTitle: "",
            courseDescription:"",
            courseStatus:"",
            isPaid: ""
        },
        lesson: {
            _id: "",
            lessonId: "",
            lessonTitle:"",
            lessonDescription:"",
            lessonStatus:"",
            isPaid:""
        },
        question:{
            _id:"",
            questionId:"",
            questionStatement:"",
            questionAudio:"",
            //questionKeySequence:[],
            questionStatus:undefined, 
            questionType:undefined
        },
        editedText:{
            editedText:"",
        },

        seasonaldiscount: {
            _id:'',
            name: "",
            discountPercentage: "",
            couponCode:"",
            startDate:"",
            endDate: "",
            status:""
        },
        groupdiscount: {
            _id:'',
            name: "",
            discountPercentage: "",
            couponCode:"",
            startDate:"",
            endDate: "",
            status:"",
            noOfUsers: ""
        },
        specialdiscount: {
            _id:'',
            personName: "",
            email: "",
            discountPercentage: "",
            couponCode:"",
            startDate:"",
            endDate: "",
            status:"",
        },
        user: {
            _id: "",
            username: "",
            email:"",
            phone:"",
            countryCode:"",
            createdOn: "",
            isSubscribed: "",
            package: "",
            nextDueDate: "",
            totalAmtPaid: "",
            status: "",
        },



    },
    plugins: [createPersistedState()],

    mutations: 
    {
        setToken(state, token) {
            state.auth.token = token;
        },

        setUser(state, adminUser) {
            state.auth.adminUser = adminUser;
            console.log('state', state.auth.adminUser);
        },

        setAppUser(state, user) {
            state.user = user;
            console.log('state', state.user);
        },

        setCourse(state, course) {
            state.course = course;
            console.log(' inside store course state', state.course);
        },

        setSeasonalDiscount(state, discount) {
            console.log('central state index');
            state.seasonaldiscount = discount;
            console.log(' inside store seasonal state', state.seasonaldiscount);
        },
        setGroupDiscount(state, discount) {
            console.log('group discount:', 'central state index');
            state.groupdiscount = discount;
            console.log(' inside store group discount state', state.groupdiscount);
        },
        setSpecialDiscount(state, discount) {
            console.log('group discount:', 'central state index');
            state.special = discount;
            console.log(' inside store group discount state', state.special);
        },

        


        setLesson(state, lesson) {
            state.lesson = lesson;
            console.log(' inside store lesson state', state.lesson);
        },
        
        setQuestion(state, question) {
            state.question = question;
            console.log(' inside store question state', state.question);
        },
        // setEditedText(state, editedText){
        //     state.editedText=editedText;
        //     console.log('inside edited text store state', state.editedText);
        // },
        removeAuth(state) {
            state.auth = {
                token: "",
                adminUser: {}
            };
        },

        removeLesson(state) {
            state.lesson = {
                _id:'',
                lessonId: "",
                lessonTitle: "",
                lessonDescription:"",
                lessonStatus:"",
                isPaid:""
                }
            },
        
        removeCourse(state) {
            state.course = {
               _id:'',
               courseId: "",
               courseTitle: "",
               courseDescription:"",
               courseStatus:"",
               isPaid:""
            }
         },
         removeSeasonalDiscount(state) {
            state.seasonaldiscount = {
               _id:'',
               name: "",
               discountPercentage: "",
               couponCode:"",
               startDate:"",
               endDate: "",
               status: "",
            }
         },
         removeGroupDiscount(state) {
            state.groupdiscount = {
                _id:'',
                name: "",
                discountPercentage: "",
                couponCode:"",
                startDate:"",
                endDate: "",
                status:"",
                noOfUsers: ""
            }
         },
 

         removeQuestion(state) {
            state.question = {
                _id:"",
                questionId:"",
                questionStatement:"",
                questionAudio:"",
                //questionKeySequence:[],
                questionStatus:undefined, 
                questionType:undefined
            }
        },

        // removeEditedText(state) {
        //     state.editedText={
        //         editedText:""
        //     }
        // },


        getAdminUser()
        {
            return this.$store.state.auth.adminUser;
        }
    },
     
    getters:{
        getAdminUser(state){
            return state.auth.adminUser;
        },
    },

    modules: {}
    
});
